module.exports = __webpack_public_path__ + "static/img/tip-amount.5af5d8b7.webp";